module.exports = __webpack_public_path__ + "img/binance-coin-bnb-logo.34f97f01.svg";